module.exports = __webpack_public_path__ + "static/media/portfolio.cdf9585f.jpg";